
import { useStore } from "vuex";
import { defineComponent, ref } from "vue";
import CharacterSave from "./CharacterSave.vue";
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";

export default defineComponent({
  components: {
    CharacterSave,
    GenericPanel,
    GenericButton
},
  name: "SaveMenu",
  setup() {
    const store = useStore();
    const panelState = ref('default')

    const closePanel = () => {
      store.dispatch('showDefaultCharStats')
    }
    return {
      state: store.state,
      panelState,
      closePanel
    };
  },
});
